import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlaskConical, ArrowRight } from 'lucide-react';

const DEMO_CTA_URL = import.meta.env.VITE_DEMO_CTA_URL || 'https://geniefactory.fr/';

export const DemoBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-orange-500 text-white flex items-center justify-between gap-3 py-2 px-6 text-sm w-full shrink-0"
      role="status"
    >
      <div className="flex items-center gap-2">
        <FlaskConical className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span className="font-semibold">{t('demo.banner')}</span>
        <span className="hidden sm:inline text-white/80">{t('demo.bannerSub')}</span>
        <span className="hidden md:inline text-white/70 text-xs">— {t('demo.bannerDataNote')}</span>
      </div>
      <a
        href={DEMO_CTA_URL}
        className="inline-flex items-center gap-1.5 rounded-md border border-white/70 bg-white/15 px-3 py-1 text-xs font-bold text-white hover:bg-white/25 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white whitespace-nowrap"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('demo.ctaButton')}
        <ArrowRight className="h-3 w-3" aria-hidden="true" />
      </a>
    </div>
  );
};
